export enum CROP_TYPES {
    FRUIT = 'fruit',
    PLANT = 'plant'
};